import { IDateComp, IDateParams } from 'ag-grid-community';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import flatpickr from 'flatpickr';

export class AggridDateFilterComponent implements IDateComp {
  private params!: IDateParams;
  private eGui!: HTMLDivElement;
  private eInput!: HTMLInputElement;
  private picker: any;
  private date: Date | null = null;

  init(params: IDateParams): void {
    this.params = params;

    flatpickr.localize(Portuguese);

    const template = `
      <input type="text" data-input placeholder="dd/mm/yyyy" class="ag-flatpickr-input ag-input-field-input ag-text-field-input"  style="::placeholder { color: transparent; width: 100%}" />
      <a class="input-button" title="Limpar" data-clear>
        <i class="fa fa-times"></i>
      </a>
    `;

    this.eGui = document.createElement('div');
    this.eGui.setAttribute('role', 'presentation');
    this.eGui.classList.add('ag-input-wrapper', 'custom-date-filter');
    this.eGui.innerHTML = template;

    this.eInput = this.eGui.querySelector('input')!;

    this.picker = flatpickr(this.eGui, {
      onChange: this.onDateChanged.bind(this),
      dateFormat: 'd/m/Y',
      wrap: true,
      locale: Portuguese
    });

    // Adiciona classe extra para alinhar o popup com o ag-Grid
    this.picker.calendarContainer.classList.add('ag-custom-component-popup');

    this.date = null;
    this.eInput.setAttribute('placeholder', 'dd/mm/yyyy');
  }

  getGui(): HTMLElement {
    this.eInput.setAttribute('placeholder', 'dd/mm/yyyy');
    return this.eGui;
  }

  onDateChanged(selectedDates: Date[]): void {
    this.date = selectedDates[0] || null;
    this.params.onDateChanged();
  }

  getDate(): Date | null {
    this.eInput.setAttribute('placeholder', 'dd/mm/yyyy');
    return this.date;
  }

  setDate(date: Date | null): void {
    this.picker.setDate(date);
    this.date = date;
  }

  setInputPlaceholder(placeholder: string): void {
    this.eInput.setAttribute('placeholder', placeholder);
  }

  destroy(): void {
    this.picker?.destroy();
  }
}
